import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-flexbox-grid';
import {Spacer} from 'layout/util'
import AnnotationsList from 'components/interactive/annotation/AnnotationsList';
import MultisourceImage from 'components/static/multisource-image'

const Img = styled(MultisourceImage)`
	width: 100%;
	object-fit: contain;
	border: 6px solid black;
	box-sizing: border-box;
	border-radius: 6px;
	@media not all and (hover: none) {
		&:hover {
			cursor: ${props=>props.isLink?"pointer":"auto"};
		}
	}
`;

const Caption = styled.div`
	font-size: 14px;
	line-height: 18px;
	font-style: italic;
	color: #666;
	padding-left: 5px;
`;

const StyledRow = styled(Row)`
	@media print {
		display: none;
	}
`;

const ImgBlock = (props) => {
	const {src, caption, nColWidth, link} = props.data;
	const { showAnnos, pageId, loggedInUserId, authorUserId, sectionId } = 
		props.annoData ? props.annoData : 
		{showAnnos: false, pageId: null, loggedInUserId: null, authorUserId: null, sectionId: null};
	const offset = Math.floor((12-nColWidth)/2)
	return(
		<StyledRow>
	    <Col 
	    	xsOffset={0} xs={12} 
	      smOffset={2} sm={8} 
	      mdOffset={showAnnos?1:offset} md={showAnnos?5:nColWidth}
	      lgOffset={showAnnos?1:offset} lg={showAnnos?5:nColWidth}
	    >
				<Spacer height={20}/>
				{link ? <a target="_blank" rel="noopener noreferrer" href={link}><Img isLink imageHandles={src} alt=""/></a> : <Img imageHandles={src} alt=""/>}
				<Caption>{caption}</Caption>
				<Spacer height={40}/>
			</Col>
			{showAnnos && 
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={2} sm={8} 
		      mdOffset={1} md={4} 
		      lgOffset={1} lg={4}
		    >
		    	<Spacer height={30}/>
					<AnnotationsList
            pageId={pageId}
						loggedInUserId={loggedInUserId}
            authorUserId={authorUserId}
            sectionId={sectionId}
          />
				</Col>
			}
		</StyledRow>
	);
}

export default ImgBlock;


// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/ImgBlock.js